export default "__VITE_ASSET__C4F9J1Zh__"